import { XGrid } from '@AMIEWEB/Common/XGrid/XGrid';
import { GridCallbackDetails, GridSortModel } from '@mui/x-data-grid-pro';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Tooltip } from '@mui/material';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getPassportPreCheckGridColumns, getPassportPreCheckGridVisibilityModel } from './PassportPreCheckGridHelper';
import { makeStyles } from 'tss-react/mui';
import { selectPassportPreferences } from './store/PassportPreCheckPreferences.selectors';
import { usePromiseTracker } from 'react-promise-tracker';

const useStyles = makeStyles()(theme => ({
  tooltipArrow: {
    color: theme.palette.components.tooltip.arrowColor,
  },
  tooltipBackground: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    color: theme.palette.components.tooltip.color,
    fontSize: '12px',
  },
  title: { fontSize: '16px', fontWeight: 400, marginLeft: '-5px' },
}));

export const PassportPreCheckPreferenceGrid = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const { promiseInProgress: isCallingAPI } = usePromiseTracker({ area: 'get-passport-preferences', delay: 0 });
  const { passportPreferencesData } = useSelector(selectPassportPreferences);

  const [tableData, setTableData] = React.useState<any[]>(passportPreferencesData || []);

  useEffect(() => {
    setTableData(passportPreferencesData || []);
  }, [passportPreferencesData]);

  const defaultColumns = [...getPassportPreCheckGridColumns(t)];
  const defaultColumnVisibilityModel = _.cloneDeep(getPassportPreCheckGridVisibilityModel);
  const defaultSortModel = [];

  const [currentColumns, setCurrentColumns] = React.useState<any[]>([...getPassportPreCheckGridColumns(t)]);
  const [currentColumnVisibilityModel, setCurrentColumnVisibilityModel] = React.useState<any>(
    _.cloneDeep(getPassportPreCheckGridVisibilityModel),
  );
  const [currentSortModel, setCurrentSortModel] = React.useState<any[]>([]);

  const onSortModelChanged = (model: GridSortModel, details: GridCallbackDetails) => {
    setCurrentSortModel(model);
  };

  const handleResetColumns = () => {
    setCurrentColumns([...getPassportPreCheckGridColumns(t)]);
    setCurrentColumnVisibilityModel(_.cloneDeep(getPassportPreCheckGridVisibilityModel));
    setCurrentSortModel([]);
  };

  return (
    <div>
      <XGrid
        apiRef={apiRef}
        defaultColumns={defaultColumns}
        defaultColumnVisibilityModel={defaultColumnVisibilityModel}
        defaultSortModel={defaultSortModel}
        columns={currentColumns}
        columnVisibilityModel={currentColumnVisibilityModel}
        sortModel={currentSortModel}
        rows={tableData || []}
        rowCount={(tableData || []).length}
        onSortModelChange={onSortModelChanged}
        onColumnVisibilityModelChange={model => {
          setCurrentColumnVisibilityModel(_.cloneDeep(model));
        }}
        loading={isCallingAPI}
        height={170}    
        title={
          <Tooltip
            classes={{ tooltip: classes.tooltipBackground, arrow: classes.tooltipArrow }}
            arrow
            title={t('candidate.passportPreCheckPreferences.titleTooltip')}
          >
            <div className={classes.title}>{t('candidate.passportPreCheckPreferences.gridTitle')}</div>
          </Tooltip>
        }
        hideFooter={true}
        toolbarProps={{
          refreshButton: false,
          resetColumns: () => {
            handleResetColumns();
            dispatch(
              globalActions.setSnackBar({
                message: t('search.grid.columnsResest'),
                severity: 'success',
              }),
            );
          },
        }}
      />
    </div>
  );
};
